import Stack from '@zenbusiness/zui/Stack';

import { QACardSkeleton } from '../components/QACard';
import { SectionGrid } from '../components/SectionGrid';
import { WebinarCardSkeleton } from '../components/WebinarCard';
import { WEBINAR_LOCALIZED_TEXT } from '../constants';

const ITEM_LENGTH = 4;

function RunningAndGrowingSkeleton() {
  return (
    <Stack gap={3}>
      {/* Webinars Section Skeleton */}
      <SectionGrid title={WEBINAR_LOCALIZED_TEXT.sections.webinars}>
        {Array.from({ length: ITEM_LENGTH }, (_, index) => (
          <WebinarCardSkeleton key={`webinars-${index}`} />
        ))}
      </SectionGrid>

      {/* Q&A section */}
      <SectionGrid title={WEBINAR_LOCALIZED_TEXT.sections.joinOurQA}>
        {Array.from({ length: ITEM_LENGTH }, (_, index) => (
          <QACardSkeleton key={`q&a-${index}`} />
        ))}
      </SectionGrid>
    </Stack>
  );
}

export default RunningAndGrowingSkeleton;
